import { RootState } from "core-integration/src/store";
import { getElementsById } from "core-integration/src/store/elements/reducers";
import { IElementsById } from "core-integration/src/store/elements/types";
import { IPickLight } from "core-integration/src/store/entries/types";
import { getRules } from "core-integration/src/store/game/reducers";
import { IRules } from "core-integration/src/store/game/types";
import { size } from "polished";
import React from "react";
import { connect } from "react-redux";
import styled, { css } from "styled-components";
import Captain from "../../img/icons/captain.svg?react";
import ViceCaptain from "../../img/icons/vice-captain.svg?react";
import x2 from "../../img/icons/x2.svg?react";

const StyledCaptain = styled(Captain)<IStyledCaptainProps>`
  ${size(14)};
  fill: ${({ theme }) => theme.colors.primary};
  color: white;

  ${(props) =>
    props.variant === "2capt" &&
    css`
      color: black;
      fill: #fac101;
    `}

  @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
    ${size(16)}
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    ${size(20)}
  }
`;

const StyledViceCaptain = styled(ViceCaptain)<IStyledCaptainProps>`
  ${size(14)};
  fill: ${({ theme }) => theme.colors.primary};
  color: white;

  ${(props) =>
    props.variant === "2capt" &&
    css`
      color: black;
      fill: #fac101;
    `}

  @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
    ${size(16)}
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    ${size(20)}
  }
`;

const StyledX2 = styled(x2)`
  ${size(14)};
  color: #131924;
  fill: #e6eeff;

  @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
    ${size(16)}
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    ${size(20)}
  }
`;

interface IPropsFromState {
  elementsById: IElementsById;
  rules: IRules | null;
}

interface IOwnProps {
  chipName: string | null;
  pick: IPickLight;
}

interface IStyledCaptainProps {
  variant?: string;
}

type Props = IPropsFromState & IOwnProps & IStyledCaptainProps;

const TeamElementIcon: React.FC<Props> = ({
  chipName,
  elementsById,
  pick,
  rules,
}) => {
  if (rules && pick.position > rules.squad_squadplay) return null;

  if (!chipName || chipName === "wildcard" || chipName === "uteam") {
    if (pick.is_captain) return <StyledCaptain />;
    if (pick.is_vice_captain) return <StyledViceCaptain />;
  }

  if (chipName === "2capt") {
    if (pick.is_captain) return <StyledCaptain variant={chipName} />;
    if (pick.is_vice_captain) return <StyledViceCaptain variant={chipName} />;
  }

  const element = elementsById[pick.element];

  if (chipName === "pdbus" && element.element_type === 2) {
    return <StyledX2 />;
  }

  return null;
};

const mapStateToProps = (state: RootState): IPropsFromState => ({
  elementsById: getElementsById(state),
  rules: getRules(state),
});

export default connect(mapStateToProps)(TeamElementIcon);
